import { render } from "./SearchExport.vue?vue&type=template&id=da79aca6&ts=true"
import script from "./SearchExport.vue?vue&type=script&lang=ts"
export * from "./SearchExport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__